import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = {
  class: "me-7 mb-4",
  style: {"display":"flex","align-items":"center"}
}
const _hoisted_5 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_6 = { class: "fw-bold d-block pt-1" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "flex-grow-1" }
const _hoisted_9 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_10 = { class: "d-flex flex-column" }
const _hoisted_11 = { class: "d-flex align-items-center mb-2" }
const _hoisted_12 = { class: "text-gray-800 text-hover-primary fs-3 fw-bolder me-1" }
const _hoisted_13 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_14 = { class: "d-flex align-items-center text-hover-primary me-5 mb-2" }
const _hoisted_15 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_16 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_17 = { class: "d-flex align-items-center text-hover-primary me-5 mb-2" }
const _hoisted_18 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_19 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_20 = { class: "d-flex align-items-center text-hover-primary mb-2" }
const _hoisted_21 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_22 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_23 = { class: "d-flex align-items-center text-hover-primary mb-2" }
const _hoisted_24 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_25 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_26 = { class: "d-flex align-items-center text-hover-primary mb-2" }
const _hoisted_27 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_28 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_29 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }
const _hoisted_30 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_31 = { class: "nav-item" }
const _hoisted_32 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_33 = {
  key: 0,
  class: "card"
}
const _hoisted_34 = { class: "card-body" }
const _hoisted_35 = {
  class: "tab-content pt-3",
  id: "kt_tabs"
}
const _hoisted_36 = { class: "card mb-5 mb-xl-10" }
const _hoisted_37 = {
  class: "card-header border-0 cursor-pointer bg-secondary",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#tranch1",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_38 = { class: "card-title m-0" }
const _hoisted_39 = { class: "fw-bolder text-dark m-0" }
const _hoisted_40 = {
  id: "tranch1",
  class: "collapse show"
}
const _hoisted_41 = { class: "collapse show" }
const _hoisted_42 = { class: "card-body border-top p-4" }
const _hoisted_43 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_44 = { class: "list-group list-group-horizontal-lg row ml-3" }
const _hoisted_45 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_46 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center"}
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px","margin-right":"10px","color":"#fff","background-color":"#1db78d"},
  class: "fas fa-book p-2"
}, null, -1)
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2" }, "Total Course(s)")
], -1)
const _hoisted_49 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_50 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center"}
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px","margin-right":"10px","color":"#fff","background-color":"#1db78d"},
  class: "fas fa-school p-2"
}, null, -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2" }, "Training Institute(s)")
], -1)
const _hoisted_53 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_54 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center"}
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px","margin-right":"10px","color":"#fff","background-color":"#1db78d"},
  class: "fas fa-users p-2"
}, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2" }, "Target Trainee(s)")
], -1)
const _hoisted_57 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_58 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center"}
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px","margin-right":"10px","color":"#fff","background-color":"#1db78d"},
  class: "fas fa-clock p-2"
}, null, -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2" }, "Batche(s)")
], -1)
const _hoisted_61 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_62 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center"}
}
const _hoisted_63 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px","margin-right":"10px","color":"#fff","background-color":"#1db78d"},
  class: "fas fa-user-circle p-2"
}, null, -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2" }, "Trainer(s)")
], -1)
const _hoisted_65 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_66 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center"}
}
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px","margin-right":"10px","color":"#fff","background-color":"rgb(7 3 5)"},
  class: "fas fa-user-circle p-2"
}, null, -1)
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", null, "Assessor(s)")
], -1)
const _hoisted_69 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_70 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center"}
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px","margin-right":"10px","color":"#fff","background-color":"rgb(7 3 5)"},
  class: "fas fa-users p-2"
}, null, -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2" }, "Enrolled Trainee(s)")
], -1)
const _hoisted_73 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_74 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center"}
}
const _hoisted_75 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px","margin-right":"10px","color":"#fff","background-color":"rgb(7 3 5)"},
  class: "fas fa-users p-2"
}, null, -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2" }, "Assessed Trainee(s)")
], -1)
const _hoisted_77 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_78 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center"}
}
const _hoisted_79 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px","margin-right":"10px","color":"#fff","background-color":"rgb(7 3 5)"},
  class: "fas fa-users p-2"
}, null, -1)
const _hoisted_80 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2" }, "Certified Trainee(s)")
], -1)
const _hoisted_81 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_82 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center"}
}
const _hoisted_83 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px","margin-right":"10px","color":"#fff","background-color":"rgb(7 3 5)"},
  class: "fas fa-users p-2"
}, null, -1)
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2" }, "Employed Trainee(s)")
], -1)
const _hoisted_85 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_86 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center"}
}
const _hoisted_87 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px","margin-right":"10px","color":"#fff","background-color":"rgb(7 3 5)"},
  class: "fas fa-users p-2"
}, null, -1)
const _hoisted_88 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2" }, "Female Trainee(s)")
], -1)
const _hoisted_89 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_90 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center"}
}
const _hoisted_91 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px","margin-right":"10px","color":"#fff","background-color":"rgb(7 3 5)"},
  class: "fas fa-users p-2"
}, null, -1)
const _hoisted_92 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2" }, "Assessed Trainee(s)(female)")
], -1)
const _hoisted_93 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_94 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center"}
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px","margin-right":"10px","color":"#fff","background-color":"rgb(13 39 227)"},
  class: "fas fa-users p-2"
}, null, -1)
const _hoisted_96 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2" }, "Certified Trainee(s)(female)")
], -1)
const _hoisted_97 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_98 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center"}
}
const _hoisted_99 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px","margin-right":"10px","color":"#fff","background-color":"#1db78d"},
  class: "fas fa-users p-2"
}, null, -1)
const _hoisted_100 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2" }, "Employed Trainee(s)(female)")
], -1)
const _hoisted_101 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_102 = {
  class: "d-flex",
  style: {"min-height":"37px","align-items":"center"}
}
const _hoisted_103 = /*#__PURE__*/_createElementVNode("i", {
  style: {"font-size":"18px","margin-right":"10px","color":"#fff","background-color":"rgb(206 98 34)"},
  class: "fas fa-running p-2"
}, null, -1)
const _hoisted_104 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2" }, "Running Batch")
], -1)
const _hoisted_105 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_106 = {
  class: "d-flex",
  style: {"min-height":"37px","text-align":"right"}
}
const _hoisted_107 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-1",
  style: {"font-weight":"bold","font-size":"18px","margin-right":"10px","color":"rgb(255, 255, 255)","background-color":"rgb(140, 14, 219)","height":"28px"}
}, " ৳ ", -1)
const _hoisted_108 = { class: "w-100" }
const _hoisted_109 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2" }, "Claim-1 PAID")
], -1)
const _hoisted_110 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_111 = {
  class: "d-flex",
  style: {"min-height":"37px","text-align":"right"}
}
const _hoisted_112 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-1",
  style: {"font-weight":"bold","font-size":"18px","margin-right":"10px","color":"rgb(255, 255, 255)","background-color":"rgb(140, 14, 219)","height":"28px"}
}, " ৳ ", -1)
const _hoisted_113 = { class: "w-100" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", null, "Claim-2 PAID")
], -1)
const _hoisted_115 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_116 = {
  class: "d-flex",
  style: {"min-height":"37px","text-align":"right"}
}
const _hoisted_117 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-1",
  style: {"font-weight":"bold","font-size":"18px","margin-right":"10px","color":"rgb(255, 255, 255)","background-color":"rgb(140, 14, 219)","height":"28px"}
}, " ৳ ", -1)
const _hoisted_118 = { class: "w-100" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", { class: "mt-2" }, "Claim-3 PAID")
], -1)
const _hoisted_120 = { class: "list-group-item col-md-2 mr-4 mb-4 card rounded px-2" }
const _hoisted_121 = {
  class: "d-flex",
  style: {"min-height":"37px","text-align":"right"}
}
const _hoisted_122 = /*#__PURE__*/_createElementVNode("div", {
  class: "p-1",
  style: {"font-weight":"bold","font-size":"18px","margin-right":"10px","color":"rgb(255, 255, 255)","background-color":"rgb(140, 14, 219)","height":"28px"}
}, " ৳ ", -1)
const _hoisted_123 = { class: "w-100" }
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", {
  class: "mt-3 px-1",
  style: {"border-top":"2px solid #1db78d !important"}
}, [
  /*#__PURE__*/_createElementVNode("h6", null, "Total Amount Paid")
], -1)
const _hoisted_125 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-4" }, null, -1)
const _hoisted_126 = {
  key: 1,
  class: "card"
}
const _hoisted_127 = { class: "card-body" }
const _hoisted_128 = {
  class: "tab-content",
  id: "kt_tabs"
}
const _hoisted_129 = { class: "card-header border-0 pt-6 px-0 mx-0" }
const _hoisted_130 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center position-relative" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Employee List")
  ])
], -1)
const _hoisted_131 = { class: "card-toolbar" }
const _hoisted_132 = {
  class: "d-flex justify-content-end",
  "data-kt-infos-table-toolbar": "base"
}
const _hoisted_133 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_134 = { class: "row" }
const _hoisted_135 = { class: "col-md-2" }
const _hoisted_136 = { class: "col-md-2" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_138 = { class: "card mb-5 mt-4 mb-xl-10" }
const _hoisted_139 = { class: "collapse show" }
const _hoisted_140 = { class: "card-body border-top p-6" }
const _hoisted_141 = { class: "row mt-1 w-100 m-0" }
const _hoisted_142 = {
  class: "col-md-12 mt-1 text-end",
  "data-v-54b12dc8": ""
}
const _hoisted_143 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-excel fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_144 = [
  _hoisted_143
]
const _hoisted_145 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-file-pdf fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_146 = [
  _hoisted_145
]
const _hoisted_147 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa fa-print fs-1",
  "data-v-54b12dc8": ""
}, null, -1)
const _hoisted_148 = [
  _hoisted_147
]
const _hoisted_149 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_150 = { key: 0 }
const _hoisted_151 = { key: 1 }
const _hoisted_152 = { key: 2 }
const _hoisted_153 = { key: 3 }
const _hoisted_154 = { key: 4 }
const _hoisted_155 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_156 = ["onClick"]
const _hoisted_157 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pencil-alt text-light" }, null, -1)
const _hoisted_158 = [
  _hoisted_157
]
const _hoisted_159 = ["onClick"]
const _hoisted_160 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt text-light" }, null, -1)
const _hoisted_161 = [
  _hoisted_160
]
const _hoisted_162 = {
  key: 2,
  class: "card"
}
const _hoisted_163 = { class: "card-body" }
const _hoisted_164 = {
  class: "tab-content pt-3",
  id: "kt_tabs"
}
const _hoisted_165 = { class: "mb-5" }
const _hoisted_166 = { class: "position-relative" }
const _hoisted_167 = {
  key: 0,
  class: "card-body p-0"
}
const _hoisted_168 = { class: "d-flex row" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder container m-0 text-primary border-bottom border-2 py-4 pl-0" }, " Entity Change Summery ")
], -1)
const _hoisted_170 = {
  key: 0,
  class: "col-md-6 text-end"
}
const _hoisted_171 = {
  class: "scroll-y me-n7 pe-7",
  id: "kt_target_change_summery_scroll"
}
const _hoisted_172 = {
  class: "table table table-borderless",
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_173 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", {
    class: "bg-secondary",
    style: {"border":"1px solid #1db78d"}
  }, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Column Name"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Old Data"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "New Data")
  ])
], -1)
const _hoisted_174 = {
  key: 0,
  style: {"border":"1px solid #1db78d"}
}
const _hoisted_175 = { key: 0 }
const _hoisted_176 = { key: 1 }
const _hoisted_177 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-4" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_EmployeeListModal = _resolveComponent("EmployeeListModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createElementVNode("img", {
                  src: _ctx.api_url + _ctx.entityInfos?.attach_file_info?.thumb_dir,
                  alt: ""
                }, null, 8, _hoisted_7)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.entityInfos.entity_name) + "(" + _toDisplayString(_ctx.entityInfos.entity_short_name) + ")", 1)
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen018.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.entityInfos?.address), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com006.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.entityInfos?.telephone), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.entityInfos?.email), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("span", _hoisted_24, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com008.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.entityInfos?.web_url), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("span", _hoisted_27, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com009.svg" })
                    ]),
                    _createTextVNode(" Active: " + _toDisplayString(_ctx.entityInfos?.active_status == 1 ? "Yes" : "No"), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("ul", _hoisted_29, [
            (_ctx.entityInfos?.entity_type_id != 1004)
              ? (_openBlock(), _createElementBlock("li", _hoisted_30, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 0 }]),
                    "data-bs-toggle": "tab",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setActiveTab($event))),
                    "data-tab-index": "0",
                    href: "#training_summary",
                    role: "tab"
                  }, " Training Summary ", 2)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("li", _hoisted_31, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 1 }]),
                "data-bs-toggle": "tab",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setActiveTab($event))),
                "data-tab-index": "1",
                href: "#employee_list",
                role: "tab"
              }, " Employee List ", 2)
            ]),
            (_ctx.updateLog && _ctx.entityInfos?.update_status == '1')
              ? (_openBlock(), _createElementBlock("li", _hoisted_32, [
                  _createElementVNode("a", {
                    class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 2 }]),
                    "data-bs-toggle": "tab",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setActiveTab($event))),
                    "data-tab-index": "2",
                    href: "#change_summery",
                    role: "tab"
                  }, " Change Summery ", 2)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ]),
    (_ctx.tabIndex === 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 0 }]),
                id: "training_summary"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countList, (info, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mb-5",
                    key: info
                  }, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("h3", _hoisted_39, _toDisplayString(index), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("div", _hoisted_43, [
                              _createElementVNode("ul", _hoisted_44, [
                                _createElementVNode("li", _hoisted_45, [
                                  _createElementVNode("div", _hoisted_46, [
                                    _hoisted_47,
                                    _createElementVNode("strong", null, _toDisplayString(info?.courses), 1)
                                  ]),
                                  _hoisted_48
                                ]),
                                _createElementVNode("li", _hoisted_49, [
                                  _createElementVNode("div", _hoisted_50, [
                                    _hoisted_51,
                                    _createElementVNode("strong", null, _toDisplayString(info?.institute), 1)
                                  ]),
                                  _hoisted_52
                                ]),
                                _createElementVNode("li", _hoisted_53, [
                                  _createElementVNode("div", _hoisted_54, [
                                    _hoisted_55,
                                    _createElementVNode("strong", null, _toDisplayString(info?.total_target_trainee), 1)
                                  ]),
                                  _hoisted_56
                                ]),
                                _createElementVNode("li", _hoisted_57, [
                                  _createElementVNode("div", _hoisted_58, [
                                    _hoisted_59,
                                    _createElementVNode("strong", null, _toDisplayString(info?.total_batches), 1)
                                  ]),
                                  _hoisted_60
                                ]),
                                _createElementVNode("li", _hoisted_61, [
                                  _createElementVNode("div", _hoisted_62, [
                                    _hoisted_63,
                                    _createElementVNode("strong", null, _toDisplayString(info?.total_trainer), 1)
                                  ]),
                                  _hoisted_64
                                ]),
                                _createElementVNode("li", _hoisted_65, [
                                  _createElementVNode("div", _hoisted_66, [
                                    _hoisted_67,
                                    _createElementVNode("strong", null, _toDisplayString(info?.total_assessor), 1)
                                  ]),
                                  _hoisted_68
                                ]),
                                _createElementVNode("li", _hoisted_69, [
                                  _createElementVNode("div", _hoisted_70, [
                                    _hoisted_71,
                                    _createElementVNode("strong", null, _toDisplayString(info?.enrolled_trainees), 1)
                                  ]),
                                  _hoisted_72
                                ]),
                                _createElementVNode("li", _hoisted_73, [
                                  _createElementVNode("div", _hoisted_74, [
                                    _hoisted_75,
                                    _createElementVNode("strong", null, _toDisplayString(info?.assessed_trainees), 1)
                                  ]),
                                  _hoisted_76
                                ]),
                                _createElementVNode("li", _hoisted_77, [
                                  _createElementVNode("div", _hoisted_78, [
                                    _hoisted_79,
                                    _createElementVNode("strong", null, _toDisplayString(info?.certified_trainees), 1)
                                  ]),
                                  _hoisted_80
                                ]),
                                _createElementVNode("li", _hoisted_81, [
                                  _createElementVNode("div", _hoisted_82, [
                                    _hoisted_83,
                                    _createElementVNode("strong", null, _toDisplayString(info?.employed_trainees), 1)
                                  ]),
                                  _hoisted_84
                                ]),
                                _createElementVNode("li", _hoisted_85, [
                                  _createElementVNode("div", _hoisted_86, [
                                    _hoisted_87,
                                    _createElementVNode("strong", null, _toDisplayString(info?.female_enrolled_trainees), 1)
                                  ]),
                                  _hoisted_88
                                ]),
                                _createElementVNode("li", _hoisted_89, [
                                  _createElementVNode("div", _hoisted_90, [
                                    _hoisted_91,
                                    _createElementVNode("strong", null, _toDisplayString(info?.female_assessed_trainees), 1)
                                  ]),
                                  _hoisted_92
                                ]),
                                _createElementVNode("li", _hoisted_93, [
                                  _createElementVNode("div", _hoisted_94, [
                                    _hoisted_95,
                                    _createElementVNode("strong", null, _toDisplayString(info?.female_certified_trainees), 1)
                                  ]),
                                  _hoisted_96
                                ]),
                                _createElementVNode("li", _hoisted_97, [
                                  _createElementVNode("div", _hoisted_98, [
                                    _hoisted_99,
                                    _createElementVNode("strong", null, _toDisplayString(info?.female_employed_trainees), 1)
                                  ]),
                                  _hoisted_100
                                ]),
                                _createElementVNode("li", _hoisted_101, [
                                  _createElementVNode("div", _hoisted_102, [
                                    _hoisted_103,
                                    _createElementVNode("strong", null, _toDisplayString(info?.running_batches), 1)
                                  ]),
                                  _hoisted_104
                                ]),
                                _createElementVNode("li", _hoisted_105, [
                                  _createElementVNode("div", _hoisted_106, [
                                    _hoisted_107,
                                    _createElementVNode("div", _hoisted_108, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.numberWithCommas(info?.claim1bill.toFixed(2))), 1)
                                    ])
                                  ]),
                                  _hoisted_109
                                ]),
                                _createElementVNode("li", _hoisted_110, [
                                  _createElementVNode("div", _hoisted_111, [
                                    _hoisted_112,
                                    _createElementVNode("div", _hoisted_113, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.numberWithCommas(info?.claim2bill.toFixed(2))), 1)
                                    ])
                                  ]),
                                  _hoisted_114
                                ]),
                                _createElementVNode("li", _hoisted_115, [
                                  _createElementVNode("div", _hoisted_116, [
                                    _hoisted_117,
                                    _createElementVNode("div", _hoisted_118, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.numberWithCommas(info?.claim3bill.toFixed(2))), 1)
                                    ])
                                  ]),
                                  _hoisted_119
                                ]),
                                _createElementVNode("li", _hoisted_120, [
                                  _createElementVNode("div", _hoisted_121, [
                                    _hoisted_122,
                                    _createElementVNode("div", _hoisted_123, [
                                      _createElementVNode("strong", null, _toDisplayString(_ctx.numberWithCommas(info?.totalBill.toFixed(2))), 1)
                                    ])
                                  ]),
                                  _hoisted_124
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128)),
                _hoisted_125
              ], 2)
            ])
          ])
        ])), [
          [_directive_loading, _ctx.summeryload]
        ])
      : _createCommentVNode("", true),
    (_ctx.tabIndex === 1)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_126, [
          _createElementVNode("div", _hoisted_127, [
            _createElementVNode("div", _hoisted_128, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 1 }]),
                id: "employee_list"
              }, [
                _createElementVNode("div", _hoisted_129, [
                  _hoisted_130,
                  _createElementVNode("div", _hoisted_131, [
                    _createElementVNode("div", _hoisted_132, [
                      (_ctx.employeeAccess)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.add && _ctx.add(...args))),
                            type: "button",
                            class: "btn btn-primary p-2"
                          }, [
                            _createTextVNode(" Add Employee "),
                            _hoisted_133
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_134, [
                    _createElementVNode("div", _hoisted_135, [
                      _createVNode(_component_el_select, {
                        class: "form-select-solid",
                        placeholder: "Select status",
                        modelValue: _ctx.active_status,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.active_status) = $event)),
                        filterable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: "Active",
                            value: "1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Active")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Inactive",
                            value: "2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Inactive")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Pending",
                            value: "0"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Pending")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Rejected",
                            value: "3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Rejected")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_option, {
                            label: "Suspended",
                            value: "4"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Suspended")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_136, [
                      _createElementVNode("button", {
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.getEmployee && _ctx.getEmployee(...args))),
                        type: "button",
                        class: "btn btn-success p-3",
                        style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                      }, [
                        _createTextVNode(" Search "),
                        _hoisted_137
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_138, [
                    (_openBlock(), _createElementBlock("div", {
                      key: _ctx.employekey,
                      id: "trainee_data",
                      class: "collapse show"
                    }, [
                      _createElementVNode("div", _hoisted_139, [
                        _createElementVNode("div", _hoisted_140, [
                          _createElementVNode("div", _hoisted_141, [
                            _createElementVNode("div", _hoisted_142, [
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-success btn-lg btn-icon fs-7 p-4",
                                title: "Download Xlse",
                                "data-v-54b12dc8": "",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.exportTrainee()))
                              }, _hoisted_144),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-danger btn-lg btn-icon fs-7 ml-3 p-4",
                                title: "Download PDF",
                                "data-v-54b12dc8": "",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.downloadPdf()))
                              }, _hoisted_146),
                              _createElementVNode("button", {
                                type: "button",
                                class: "btn btn-dark btn-lg btn-icon fs-7 ml-3 p-4",
                                title: "Print",
                                "data-v-54b12dc8": "",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.printPdf()))
                              }, _hoisted_148)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_149, [
                            _createVNode(_component_Datatable, {
                              "table-data": _ctx.tableData,
                              "table-header": _ctx.tableHeader,
                              "enable-items-per-page-dropdown": true
                            }, {
                              "cell-sl": _withCtx(({ row }) => [
                                _createTextVNode(_toDisplayString(row.id), 1)
                              ]),
                              "cell-name": _withCtx(({ row: infos }) => [
                                _createTextVNode(_toDisplayString(infos?.employee?.name), 1)
                              ]),
                              "cell-designation": _withCtx(({ row: infos }) => [
                                _createTextVNode(_toDisplayString(infos?.employee?.designation), 1)
                              ]),
                              "cell-role": _withCtx(({ row: infos }) => [
                                _createTextVNode(_toDisplayString(infos?.entitytyperole?.role_title), 1)
                              ]),
                              "cell-mobile": _withCtx(({ row: infos }) => [
                                _createTextVNode(_toDisplayString(infos?.employee?.mobile), 1)
                              ]),
                              "cell-email": _withCtx(({ row: infos }) => [
                                _createTextVNode(_toDisplayString(infos?.employee?.email), 1)
                              ]),
                              "cell-status": _withCtx(({ row: infos }) => [
                                (infos?.employee?.active_status == 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_150, _toDisplayString("Pending")))
                                  : _createCommentVNode("", true),
                                (infos?.employee?.active_status == 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_151, _toDisplayString("Active")))
                                  : _createCommentVNode("", true),
                                (infos?.employee?.active_status == 2)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_152, _toDisplayString("Inactive")))
                                  : _createCommentVNode("", true),
                                (infos?.employee?.active_status == 3)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_153, _toDisplayString("Reject")))
                                  : _createCommentVNode("", true),
                                (infos?.employee?.active_status == 4)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_154, _toDisplayString("Suspend")))
                                  : _createCommentVNode("", true)
                              ]),
                              "cell-actions": _withCtx(({ row: infos }) => [
                                _createVNode(_component_router_link, {
                                  class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1",
                                  to: {
                              name: 'entityEmployeeProfiles',
                              params: { id: infos?.employee?.id },
                            }
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_155
                                  ]),
                                  _: 2
                                }, 1032, ["to"]),
                                (_ctx.employeeAccess)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      "data-kt-drawer-toggle": "true",
                                      "data-kt-drawer-target": "#kt_drawer_employee_list",
                                      onClick: ($event: any) => (_ctx.edit(infos)),
                                      id: "kt_drawer_employee_list_button",
                                      title: "Edit",
                                      class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                    }, _hoisted_158, 8, _hoisted_156))
                                  : _createCommentVNode("", true),
                                (_ctx.employeeAccess)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      onClick: ($event: any) => (_ctx.Delete(infos?.employee?.id)),
                                      class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm"
                                    }, _hoisted_161, 8, _hoisted_159))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["table-data", "table-header"])
                          ])
                        ])
                      ])
                    ]))
                  ])
                ])
              ], 2)
            ])
          ])
        ])), [
          [_directive_loading, _ctx.empload]
        ])
      : _createCommentVNode("", true),
    (_ctx.tabIndex === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_162, [
          _createElementVNode("div", _hoisted_163, [
            _createElementVNode("div", _hoisted_164, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 2 }]),
                id: "change_summery"
              }, [
                _createElementVNode("div", _hoisted_165, [
                  _createElementVNode("div", _hoisted_166, [
                    (_ctx.entityInfos?.update_status == '1')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
                          _createElementVNode("div", _hoisted_168, [
                            _hoisted_169,
                            (_ctx.entity_type == 1004)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_170, [
                                  _createElementVNode("button", {
                                    title: "Approve",
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.Approve())),
                                    class: "text-light btn btn-bg-success btn-active-color-primary btn-sm me-1"
                                  }, " Approve "),
                                  _createElementVNode("button", {
                                    title: "Reject",
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.Reject())),
                                    class: "btn text-light btn-bg-danger btn-active-color-primary btn-sm"
                                  }, " Reject ")
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_171, [
                            _createElementVNode("table", _hoisted_172, [
                              _hoisted_173,
                              _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableColumn, (cell, i) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.updateLog, (log, idx) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
                                        (idx == cell.key)
                                          ? (_openBlock(), _createElementBlock("tr", _hoisted_174, [
                                              _createElementVNode("th", null, _toDisplayString(cell.name), 1),
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (item, index) => {
                                                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                                                  (index == cell.key)
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_175, [
                                                        (index == 'entity_type_id')
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                              _createTextVNode(_toDisplayString(_ctx.entityInfos?.entity_type_info?.name), 1)
                                                            ], 64))
                                                          : (index == 'industry_sector')
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _createTextVNode(_toDisplayString(_ctx.entityInfos?.industry_sector_info?.name), 1)
                                                              ], 64))
                                                            : (index == 'division')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                  _createTextVNode(_toDisplayString(_ctx.entityInfos?.division_info
                                      ?.division_name_eng), 1)
                                                                ], 64))
                                                              : (index == 'district')
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                    _createTextVNode(_toDisplayString(_ctx.entityInfos?.district_info
                                      ?.district_name_eng), 1)
                                                                  ], 64))
                                                                : (index == 'sub_district')
                                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                                                      _createTextVNode(_toDisplayString(_ctx.entityInfos?.sub_district_info
                                      ?.upazila_name_eng), 1)
                                                                    ], 64))
                                                                  : (index == 'is_bill_author')
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                                                        _createTextVNode(_toDisplayString(_ctx.entityInfos?.is_bill_author == 1
                                    ? "Yes"
                                    : "No"), 1)
                                                                      ], 64))
                                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                                                        _createTextVNode(_toDisplayString(item), 1)
                                                                      ], 64))
                                                      ]))
                                                    : _createCommentVNode("", true),
                                                  (index == cell.key)
                                                    ? (_openBlock(), _createElementBlock("td", _hoisted_176, [
                                                        (index == 'entity_type_id')
                                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                              _createTextVNode(_toDisplayString(_ctx.updateLog?.entity_type_info?.name), 1)
                                                            ], 64))
                                                          : (index == 'industry_sector')
                                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                _createTextVNode(_toDisplayString(_ctx.updateLog?.industry_sector_info?.name), 1)
                                                              ], 64))
                                                            : (index == 'division')
                                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                                                  _createTextVNode(_toDisplayString(_ctx.updateLog?.division_info?.division_name_eng), 1)
                                                                ], 64))
                                                              : (index == 'district')
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                                    _createTextVNode(_toDisplayString(_ctx.updateLog?.district_info?.district_name_eng), 1)
                                                                  ], 64))
                                                                : (index == 'sub_district')
                                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                                                      _createTextVNode(_toDisplayString(_ctx.updateLog?.sub_district_info
                                      ?.upazila_name_eng), 1)
                                                                    ], 64))
                                                                  : (index == 'is_bill_author')
                                                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                                                        _createTextVNode(_toDisplayString(_ctx.updateLog?.is_bill_author == 1
                                    ? "Yes"
                                    : "No"), 1)
                                                                      ], 64))
                                                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                                                        _createTextVNode(_toDisplayString(log), 1)
                                                                      ], 64))
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                              }), 128))
                                            ]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 128))
                                  ], 64))
                                }), 128))
                              ])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _hoisted_177
              ], 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_EmployeeListModal)
  ], 64))
}